import { doc, getDoc, setDoc, getFirestore } from 'firebase/firestore';
import { app } from './config';
import type { UserBalance } from '../../../types/user';

const db = getFirestore(app);

export async function initializeUserBalance(userId: string): Promise<void> {
  const userRef = doc(db, 'userBalances', userId);
  const userDoc = await getDoc(userRef);

  if (!userDoc.exists()) {
    await setDoc(userRef, {
      freeGenerations: 1,
      paidGenerations: 0
    });
  }
}

export async function getUserBalance(userId: string): Promise<UserBalance> {
  const userRef = doc(db, 'userBalances', userId);
  const userDoc = await getDoc(userRef);

  if (!userDoc.exists()) {
    await initializeUserBalance(userId);
    return { freeGenerations: 1, paidGenerations: 0 };
  }

  return userDoc.data() as UserBalance;
}

export async function decrementBalance(userId: string): Promise<boolean> {
  const userRef = doc(db, 'userBalances', userId);
  const balance = await getUserBalance(userId);

  if (balance.freeGenerations > 0) {
    await setDoc(userRef, {
      ...balance,
      freeGenerations: balance.freeGenerations - 1
    });
    return true;
  } else if (balance.paidGenerations > 0) {
    await setDoc(userRef, {
      ...balance,
      paidGenerations: balance.paidGenerations - 1
    });
    return true;
  }

  return false;
}
